module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMTYgNjQwYTQ4IDQ4IDAgMSAwIDAgOTYgNDggNDggMCAwIDAgMC05NnogbTAtMjI0YTQ4IDQ4IDAgMSAwIDAgOTYgNDggNDggMCAwIDAgMC05NnogbTAtMjI0YTQ4IDQ4IDAgMSAwIDAgOTYgNDggNDggMCAwIDAgMC05NnoiIGZpbGw9IiMwIiBwLWlkPSIzMTYxIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Overflow menu vertical-filled.svg
// module id = S5Gv
// module chunks = 73